export default __webpack_public_path__ + "static/media/gold hat.aea59880.svg";